"use clinet"
import { forwardRef, ReactNode } from 'react';
import Link from 'next/link';

const focusReset = "focus:outline-none focus:ring-0 focus:ring-transparent focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-transparent transition-all duration-300";
export const variants = {
    default: 'text-foreground hover:text-primary',
    defaultnullhover: 'text-foreground',
    defaultpr: 'text-primary hover:text-foreground',
    primary: `bg-[var(--color-primary)] hover:bg-[var(--color-primary-foreground)] text-white shadow-lg shadow-[var(--color-primary)/20] ${focusReset}`,
    secondary: 'bg-panel-600 hover:bg-panel-500 text-text-primary border border-border-default',
    outline: 'bg-transparent hover:bg-panel-600 text-text-primary border border-border-default hover:border-border-strong',
    ghost: 'bg-transparent hover:bg-panel-500 text-text-secondary hover:text-text-primary',
    danger: 'bg-error-500 hover:bg-error-400 text-white shadow-lg shadow-error-500/20',
    success: 'bg-success-500 hover:bg-success-400 text-white shadow-lg shadow-success-500/20',
    blur: 'bg-white/8 text-[#e8e8e8] backdrop-blur-[20px] hover:bg-white/4 hover:text-primary transition-all duration-300',
    white: 'bg-[#f5f5f5] text-[#1a1a1a] backdrop-blur-[20px]',
} as const;

const sizes = {
    none: '!p-0 text-[12px]',
    sm: 'px-3 py-1.5 text-[12px]',
    md: 'px-3 py-1.5 md:px-5 md:py-2.5 text-[12px]',
    lg: 'px-3 py-1.5 lg:px-6 lgpy-3 text-base sm:text-[12px]',
} as const;

export interface LinkButtonProps {
    children: ReactNode;
    href: string;
    alt?: string;
    variant?: keyof typeof variants;
    size?: keyof typeof sizes;
    className?: string;
    title?: string;
    disabled?: boolean;
    loading?: boolean;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    // icon?: ComponentType<{ className?: string }>;
    // iconPosition?: 'left' | 'right';
    fullWidth?: boolean;
    target?: '_blank' | '_self' | '_parent' | '_top';
    'aria-label'?: string;
}

const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(({
    children,
    href,
    title,
    variant = 'primary',
    size = 'md',
    className = '',
    disabled = false,
    loading = false,
    // icon: Icon,
    // iconPosition = 'left',
    fullWidth = false,
    target,
    ...props
}, ref) => {
    return (
        <Link
            href={disabled ? '#' : href}
            ref={ref}
            target={target}
            title={title}
            className={`
        inline-flex items-center justify-center gap-2
        font-semibold rounded-lg
        font-sm md:font-md
        transition-all duration-200
        focus:outline-none focus:ring-2 focus:ring-accent-500/50 focus:ring-offset-2 focus:ring-offset-panel-800 my-no-focus
        ${disabled ? 'opacity-50 pointer-events-none cursor-not-allowed' : ''}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
            {...props}
        >
            {loading ? (
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
            ) : (
                <>
                    {/* {iconPosition === 'left' && Icon ? <Icon className="w-4 h-4" /> : null} */}
                    {children}
                    {/* {iconPosition === 'right' && Icon ? <Icon className="w-4 h-4" /> : null} */}
                </>
            )}
        </Link>
    );
});

LinkButton.displayName = 'LinkButton';

export default LinkButton;